/*
 * Shared accordion — smooth height open/close for any <details data-acc>.
 *
 * One implementation for every accordion on the site (PDP Description / Scent
 * notes / FAQs + the nested FAQ cards, the standalone FAQs section, the footer
 * menu columns, the mobile filter drawer). Document-delegated, so accordions
 * injected later — the filter drawer's fetch-and-swap body, theme-editor
 * section reloads — animate with no re-init.
 *
 * Panel measured/animated = the details' direct [data-acc-panel] child
 * (fallback: the summary's next element sibling). offsetHeight is used to
 * measure, so panels with their own max-height (the scrollable filter lists)
 * animate to their capped height and stay scrollable afterwards.
 *
 * Honours prefers-reduced-motion (instant native toggle). No-JS degrades to the
 * native <details> instant toggle. The [open] attribute is still the source of
 * truth, so CSS that keys off [open] (chevron rotation, +/- swap) is unaffected.
 */
(function () {
  var DURATION = 320;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelOf(details, summary) {
    var explicit = details.querySelector(':scope > [data-acc-panel]');
    if (explicit) return explicit;
    return summary && summary.nextElementSibling;
  }

  function clearInline(panel) {
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  }

  function onEnd(panel, done) {
    var finished = false;
    function finish(e) {
      if (e && e.target !== panel) return;
      if (finished) return;
      finished = true;
      panel.removeEventListener('transitionend', finish);
      done();
    }
    panel.addEventListener('transitionend', finish);
    // Fallback for when transitionend never fires (e.g. zero-height content).
    setTimeout(finish, DURATION + 60);
  }

  function open(details, panel) {
    details.open = true;
    if (reduced() || !panel) return;
    details.dataset.accAnimating = '1';
    var target = panel.offsetHeight; // visible now; respects any CSS max-height
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    panel.getBoundingClientRect(); // force reflow
    panel.style.transition = 'height ' + DURATION + 'ms ease';
    panel.style.height = target + 'px';
    onEnd(panel, function () {
      clearInline(panel);
      delete details.dataset.accAnimating;
    });
  }

  function close(details, panel) {
    if (reduced() || !panel) {
      details.open = false;
      return;
    }
    details.dataset.accAnimating = '1';
    panel.style.overflow = 'hidden';
    panel.style.height = panel.offsetHeight + 'px';
    panel.getBoundingClientRect(); // force reflow
    panel.style.transition = 'height ' + DURATION + 'ms ease';
    panel.style.height = '0px';
    onEnd(panel, function () {
      details.open = false;
      clearInline(panel);
      delete details.dataset.accAnimating;
    });
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    // A <summary> is always a direct child of its <details>; only handle ours.
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.hasAttribute('data-acc')) return;
    e.preventDefault();
    if (details.dataset.accAnimating) return;
    var panel = panelOf(details, summary);
    if (details.open) {
      close(details, panel);
    } else {
      open(details, panel);
    }
  });
})();
